module.exports = __webpack_public_path__ + "img/back_26.193dd625.svg";